@if (dataContext) {
  <div class="form-group">
    <div class="header">
      <h1>
        {{ 'SEND_INVOICES_FORM.EXPIRES_LABEL' | translate }}: {{ from.year }} {{ monthToString(from.month) | translate
        }}{{ samePeriod ? '' : ' - ' + to.year + ' ' + (monthToString(to.month) | translate) }}
      </h1>
    </div>
    @for (model of dataContext; track model) {
      <app-invoices-overview [dataContext]="model"></app-invoices-overview>
      <div class="row">
        <div class="col-12 col-md-4"></div>
        <div class="col-12 col-md-4"></div>
        <div class="col-12 col-md-4"></div>
      </div>
      @if (!autoAttest) {
        <app-information-block [text]="'INVOICE.INFORMATION_TEXT.CREATE_INVOICE' | translate" />
      }
      @if (autoAttest) {
        <app-information-block [text]="'INVOICE.INFORMATION_TEXT.CREATE_INVOICE_AUTOATTEST' | translate" />
      }
      <app-list-view [columnDefinition]="columnDefinition" [itemsSource]="model.invoices" [preferencesKey]="'preview-invoices.list'"></app-list-view>
    }
  </div>
}
